module.exports = __webpack_public_path__ + "files/5b4a7904a3e041018526a00dba59ee48.png";


//////////////////
// WEBPACK FOOTER
// ./images/logoWhite.png
// module id = 1696
// module chunks = 60